import { render, staticRenderFns } from "./ViewToSortNewModal.vue?vue&type=template&id=69e579cf&scoped=true&"
import script from "./ViewToSortNewModal.vue?vue&type=script&lang=js&"
export * from "./ViewToSortNewModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewToSortNewModal.vue?vue&type=style&index=0&id=69e579cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e579cf",
  null
  
)

export default component.exports